/** Konstanter for Faktura-modulen (utgående fakturering). */
import { FileText, Send, CheckCircle2, AlertTriangle, CircleDollarSign, Undo2, Clock, Scale, Receipt, BellRing, Repeat } from "lucide-react";

export const SALES_STATUS = {
  kladd: { label: "Kladd", cls: "status-avvist", icon: FileText },
  utstedt: { label: "Utstedt", cls: "status-til_betaling", icon: Clock },
  sendt: { label: "Sendt", cls: "status-ma_kontrolleres", icon: Send },
  delvis_betalt: { label: "Delvis betalt", cls: "status-forfaller_snart", icon: CircleDollarSign },
  betalt: { label: "Betalt", cls: "status-betalt", icon: CheckCircle2 },
  forfalt: { label: "Forfalt", cls: "status-forfalt", icon: AlertTriangle },
  kreditert: { label: "Kreditert", cls: "status-avvist", icon: Undo2 },
  sanert: { label: "Sanert", cls: "status-avtalegiro", icon: Scale },
};

export const SALES_TABS = [
  { value: "alle", label: "Alle" },
  { value: "kladd", label: "Kladd" },
  { value: "apen", label: "Ubetalt" },
  { value: "forfalt", label: "Forfalt" },
  { value: "betalt", label: "Betalt" },
  { value: "kreditnota", label: "Kreditnota" },
  { value: "sanert", label: "Sanert" },
];

/** E-postlogg (Faktura → E-postlogg): dokumenttyper og sendestatus. */
export const EMAIL_DOC_TYPES = {
  faktura: { label: "Faktura", icon: Receipt },
  kreditnota: { label: "Kreditnota", icon: Undo2 },
  purring: { label: "Purring", icon: BellRing },
  inkassovarsel: { label: "Inkassovarsel", icon: AlertTriangle },
  gjentakende: { label: "Gjentakende faktura", icon: Repeat },
};

export const EMAIL_STATUS = {
  sendt: { label: "Sendt", cls: "status-betalt" },
  feilet: { label: "Feilet", cls: "status-forfalt" },
  ikke_konfigurert: { label: "Ikke konfigurert", cls: "status-forfaller_snart" },
};

export const EMAIL_TRIGGERS = { manuell: "Manuelt", batch: "Purrekjøring", gjentakende: "Gjentakende" };

export const VAT_RATES = [25, 15, 12, 0];
export const UNITS = ["stk", "timer", "dag", "mnd", "kg", "m", "m2", "km", "pakke", "tjeneste"];

/** Norske organisasjonsformer (speiler backend services/sales.py ENTITY_TYPES). */
export const ENTITY_TYPES = {
  privat: "Privatperson",
  enk: "Enkeltpersonforetak (ENK)",
  as: "Aksjeselskap (AS)",
  asa: "Allmennaksjeselskap (ASA)",
  ans: "Ansvarlig selskap (ANS)",
  da: "Selskap med delt ansvar (DA)",
  nuf: "Norskregistrert utenlandsk foretak (NUF)",
  sa: "Samvirkeforetak (SA)",
  brl: "Borettslag (BRL)",
  sameie: "Eierseksjonssameie",
  forening: "Forening / lag / innretning",
  stiftelse: "Stiftelse",
  annet: "Annet",
};

/** Kort etikett for merker/velgere. */
export const ENTITY_SHORT = { privat: "Privat", enk: "ENK", as: "AS", asa: "ASA", ans: "ANS", da: "DA", nuf: "NUF", sa: "SA", brl: "BRL", sameie: "Sameie", forening: "Forening", stiftelse: "Stiftelse", annet: "Annet" };

export const SALES_EVENTS = {
  opprettet: "Kladd opprettet",
  utstedt: "Utstedt",
  sendt: "Sendt på e-post",
  betaling: "Betaling registrert",
  betaling_slettet: "Betaling fjernet",
  purring: "Purring",
  purring_sendt_pa_nytt: "Purring sendt på nytt",
  kreditert: "Kreditert",
  sanert: "Sanert mot",
  sanering_opphevet: "Sanering opphevet",
};

export const PAYMENT_METHODS = ["Bankoverføring", "Vipps", "Kort", "Kontant", "Annet"];
